import { useContext } from 'react';
import GruserContext from '../context/GruserContext/GruserContext';
import { generateGruserObjectId } from '../redux/helpers';
export const useGruser = ()=>{
    return useContext(GruserContext);
};
export const useGruserObjectId = ()=>{
    const { gruser } = useGruser();
    return gruser && generateGruserObjectId(gruser);
};
export default useGruser;
